import { render, staticRenderFns } from "./program_activity.vue?vue&type=template&id=2e411661&scoped=true"
import script from "./program_activity.vue?vue&type=script&lang=js"
export * from "./program_activity.vue?vue&type=script&lang=js"
import style0 from "./program_activity.vue?vue&type=style&index=0&id=2e411661&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e411661",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e411661')) {
      api.createRecord('2e411661', component.options)
    } else {
      api.reload('2e411661', component.options)
    }
    module.hot.accept("./program_activity.vue?vue&type=template&id=2e411661&scoped=true", function () {
      api.rerender('2e411661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/visit_detail/components/program_activity.vue"
export default component.exports